import React, { useState } from 'react';
import { GameMode } from '@shared/types';

interface MainMenuProps {
  onCreateRoom: (nickname: string, mode: GameMode) => void;
  onJoinRoom: (nickname: string, code: string, mode: GameMode) => void;
  isConnected: boolean;
}

type MenuPanel = 'none' | 'create' | 'join';

export const MainMenu: React.FC<MainMenuProps> = ({
  onCreateRoom,
  onJoinRoom,
  isConnected,
}) => {
  const [panel, setPanel] = useState<MenuPanel>('none');
  const [nickname, setNickname] = useState('');
  const [roomCode, setRoomCode] = useState('');
  const [mode, setMode] = useState<GameMode>('101');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCreate = () => {
    if (!nickname.trim()) { setError('Rumuzunuzu girin'); return; }
    setLoading(true);
    setError('');
    onCreateRoom(nickname.trim(), mode);
    setTimeout(() => setLoading(false), 3000);
  };

  const handleJoin = () => {
    if (!nickname.trim()) { setError('Rumuzunuzu girin'); return; }
    if (!roomCode.trim()) { setError('Oda kodunu girin'); return; }
    setLoading(true);
    setError('');
    onJoinRoom(nickname.trim(), roomCode.trim().toUpperCase(), mode);
    setTimeout(() => setLoading(false), 3000);
  };

  return (
    <div className="menu-screen">
      <div className="menu-container">
        {/* Logo */}
        <div className="menu-logo">
          <div className="menu-logo-title">OKEY</div>
          <div className="menu-logo-sub">101 PLUS</div>
        </div>

        {/* Connection indicator */}
        {!isConnected && (
          <div style={{
            fontSize: 12,
            color: 'var(--color-danger)',
            background: 'rgba(204,51,51,0.1)',
            border: '1px solid rgba(204,51,51,0.3)',
            borderRadius: 'var(--radius-sm)',
            padding: '6px 14px',
          }}>
            ⚡ Sunucuya bağlanıyor...
          </div>
        )}

        {/* Mode selector */}
        <div className="mode-toggle" style={{ width: '100%' }}>
          <button
            className={`mode-option ${mode === '101' ? 'active' : ''}`}
            onClick={() => setMode('101')}
          >
            101 Okey
          </button>
          <button
            className={`mode-option ${mode === 'okey' ? 'active' : ''}`}
            onClick={() => setMode('okey')}
          >
            Normal Okey
          </button>
        </div>

        {/* Main buttons */}
        {panel === 'none' && (
          <div className="menu-buttons">
            <button
              className="menu-btn menu-btn-primary"
              onClick={() => setPanel('create')}
              disabled={!isConnected}
            >
              ODA KUR
            </button>
            <button
              className="menu-btn menu-btn-secondary"
              onClick={() => setPanel('join')}
              disabled={!isConnected}
            >
              ODAYA KATIL
            </button>
          </div>
        )}

        {/* Create Room Form */}
        {panel === 'create' && (
          <div className="form-panel">
            <div className="form-panel-title">ODA KUR</div>
            <input
              className="input"
              placeholder="Rumuzunuz"
              value={nickname}
              maxLength={20}
              onChange={e => setNickname(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleCreate()}
              autoFocus
            />
            {error && <div style={{ fontSize: 12, color: 'var(--color-danger)' }}>{error}</div>}
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-ghost" onClick={() => { setPanel('none'); setError(''); }}>
                GERİ
              </button>
              <button
                className="btn btn-green"
                style={{ flex: 1 }}
                onClick={handleCreate}
                disabled={loading || !isConnected}
              >
                {loading ? 'Oluşturuluyor...' : 'ODA KUR'}
              </button>
            </div>
          </div>
        )}

        {/* Join Room Form */}
        {panel === 'join' && (
          <div className="form-panel">
            <div className="form-panel-title">ODAYA KATIL</div>
            <input
              className="input"
              placeholder="Rumuzunuz"
              value={nickname}
              maxLength={20}
              onChange={e => setNickname(e.target.value)}
            />
            <input
              className="input"
              placeholder="Oda Kodu (örn: A7K29)"
              value={roomCode}
              maxLength={6}
              onChange={e => setRoomCode(e.target.value.toUpperCase())}
              onKeyDown={e => e.key === 'Enter' && handleJoin()}
              style={{ letterSpacing: 4, fontWeight: 700 }}
            />
            {error && <div style={{ fontSize: 12, color: 'var(--color-danger)' }}>{error}</div>}
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-ghost" onClick={() => { setPanel('none'); setError(''); }}>
                GERİ
              </button>
              <button
                className="btn btn-orange"
                style={{ flex: 1 }}
                onClick={handleJoin}
                disabled={loading || !isConnected}
              >
                {loading ? 'Bağlanıyor...' : 'KATIL'}
              </button>
            </div>
          </div>
        )}

        <div className="menu-footer">
          <span>okey.autogram.cc</span>
          <span style={{ color: isConnected ? 'var(--color-online)' : 'var(--color-danger)' }}>
            ● {isConnected ? 'Bağlı' : 'Bağlantı yok'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MainMenu;
